// extracted by mini-css-extract-plugin
module.exports = {"benefitCard":"benefit-card_benefitCard__vyM1j","image":"benefit-card_image__cYS8Y","title":"benefit-card_title__fXtxL","learnMoreButton":"benefit-card_learnMoreButton__DROqq"};